module.exports = __webpack_public_path__ + "static/media/tipos_activos-import.51493b17.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tipos_activos-import.csv
// module id = ./src/assets/tipos_activos-import.csv
// module chunks = 11